import { useRef, useState,useEffect } from "react";
import { Button } from "antd";
import { FullscreenOutlined, FullscreenExitOutlined } from "@ant-design/icons";

const FullScreenButton = ({ targetRef,onFullScreen }) => {
  const [isFullScreen, setIsFullScreen] = useState(false);

  const toggleFullScreen = () => {
    if (!document.fullscreenElement) {
      if (targetRef.current) {
        targetRef.current.requestFullscreen().catch((err) => {
          console.error("Error enabling fullscreen:", err);
        });
        setIsFullScreen(true);
        onFullScreen(true)
      }
    } else {
      document.exitFullscreen();
      setIsFullScreen(false);
      onFullScreen(false)
    }
  };

  const handleFullScreenChange = () => {
    const isNowFullScreen = Boolean(document.fullscreenElement);
    setIsFullScreen(isNowFullScreen);
    onFullScreen(isNowFullScreen);
  };

  useEffect(() => {
    document.addEventListener("fullscreenchange", handleFullScreenChange);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullScreenChange);
    };
  }, []);

  return (
    <Button type="primary" onClick={toggleFullScreen} icon={isFullScreen ? <FullscreenExitOutlined /> : <FullscreenOutlined />}>
      {/* {isFullScreen ? "Exit Fullscreen" : "Go Fullscreen"} */}
    </Button>
  );
};

export default FullScreenButton;
